/**
 * 팝업 url
 */

function getPopupURL(key) {
  const { dealNo } = TMON.htStaticData.htDealInfo;
  const prefixURL = TMON.htLocal.htURL.deal_m;

  return `${prefixURL}/popup/${key}/${dealNo}?`;
}

function getDeployPhase() {
  const deployPhase = TMON.sDeployPhase.toLowerCase();
  if (deployPhase === "local") return "dev";
  if (deployPhase === "release" && location.host.indexOf("stage") > -1) {
    return "stage";
  }
  return deployPhase;
}

/**
 * @description showView param 이 stringJosn 형태인 callApp (앱 버전 6.3.0 버전 이상 부터 사용가능)
 * @param {
 *  title(String) : 헤더 타이틀
 *  url(String) : 웹 URL
 *  modal(Bool) : 페이지 모달여부
 *  needLogin(Bool) : 로그인 필요여부
 *  needNavigation(Bool) : 하단 웹컨트롤러 바 노출 여부(뒤로가기, 앞으로가기, 새로고침, 닫기 등) isParentReload(Bool) : 부모 뷰 새로고침 여부
 *  isCartShow(Bool) : 헤더 카트버튼 노출 여부
 *  isAlarmShow(Bool) : 헤더 알람버튼 노출 여부
 *  isTabBarShow(Bool) : 하단탭바(카테고리, 검색, 홈, 찜, 마이티몬) 노출 여부
 * } showViewParamJsonString 콜앱에서 사용할 옵션 정보 jsonStirng 형식 준수 필수!
 */
function showViewJsonStringCallApp(showViewParamJsonString) {
  TMON.app.callApp("webview", "showView", showViewParamJsonString);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getPopupURL,
  getDeployPhase,
  showViewJsonStringCallApp,
};
